import * as yup from "yup";
import moment from "moment";

import { UKRegexp } from "@/shared/regexp";

export const incomeSchema = yup
  .object({
    base_salary: yup
      .number()
      .nullable()
      .transform((v) => (Number.isNaN(v) ? null : v))
      .typeError("Enter a valid number")
      .max(1000000000, "Base salary must be less than £1,000,000,000")
      .optional(),
    baseSalary: yup
      .number()
      .nullable()
      .transform((v) => (Number.isNaN(v) ? null : v))
      .typeError("Enter a valid number")
      .max(1000000000, "Base salary must be less than £1,000,000,000")
      .optional(),
    bonus_income: yup
      .number()
      .nullable()
      .transform((v) => (Number.isNaN(v) ? null : v))
      .typeError("Enter a valid number")
      .max(1000000000, "Bonus must be less than £1,000,000,000")
      .optional(),
    bonusIncome: yup
      .number()
      .nullable()
      .transform((v) => (Number.isNaN(v) ? null : v))
      .typeError("Enter a valid number")
      .max(1000000000, "Bonus must be less than £1,000,000,000")
      .optional(),
    commission: yup
      .number()
      .nullable()
      .transform((v) => (Number.isNaN(v) ? null : v))
      .typeError("Enter a valid number")
      .max(1000000000, "Commission must be less than £1,000,000,000")
      .optional(),
    overtime_income: yup
      .number()
      .nullable()
      .transform((v) => (Number.isNaN(v) ? null : v))
      .typeError("Enter a valid number")
      .max(1000000000, "Overtime income must be less than £1,000,000,000")
      .optional(),
    overtimeIncome: yup
      .number()
      .nullable()
      .transform((v) => (Number.isNaN(v) ? null : v))
      .typeError("Enter a valid number")
      .max(1000000000, "Overtime income must be less than £1,000,000,000")
      .optional(),
    other_income: yup
      .number()
      .nullable()
      .transform((v) => (Number.isNaN(v) ? null : v))
      .typeError("Enter a valid number")
      .max(1000000000, "Other income must be less than £1,000,000,000")
      .optional(),
    otherIncome: yup
      .number()
      .nullable()
      .transform((v) => (Number.isNaN(v) ? null : v))
      .typeError("Enter a valid number")
      .max(1000000000, "Other income must be less than £1,000,000,000")
      .optional(),
  })
  .test("atLeastOneValid", (value, { createError }) => {
    if (
      !(
        value.base_salary ||
        value.bonus_income ||
        value.commission ||
        value.overtime_income ||
        value.other_income ||
        value.baseSalary ||
        value.bonusIncome ||
        value.overtimeIncome ||
        value.otherIncome
      )
    )
      return createError({
        path: "customError",
        message: "Please provide at least one income",
      });
    else return true;
  });

export const expenditureSchema = yup.object({
  personalLoans: yup
    .number()
    .nullable()
    .max(1000000000, "Personal loans must be less than £1,000,000,000")
    .transform((value) => (isNaN(value) ? undefined : value))
    .optional(),
  vehicleLoans: yup
    .number()
    .nullable()
    .max(1000000000, "Vehicle loans must be less than £1,000,000,000")
    .transform((value) => (isNaN(value) ? undefined : value))
    .optional(),
  studentLoans: yup
    .number()
    .nullable()
    .max(1000000000, "Student loans must be less than £1,000,000,000")
    .transform((value) => (isNaN(value) ? undefined : value))
    .optional(),
  creditCardsLoans: yup
    .number()
    .nullable()
    .max(1000000000, "Credit cards loans income must be less than £1,000,000,000")
    .transform((value) => (isNaN(value) ? undefined : value))
    .optional(),
  childcareExpenses: yup
    .number()
    .nullable()
    .max(1000000000, "Childcare expenses must be less than £1,000,000,000")
    .transform((value) => (isNaN(value) ? undefined : value))
    .optional(),
});

export const createApplicationSchema = yup
  .object({
    // full_name: yup
    //   .string()
    //   .required("Enter your full name")
    //   .min(3, "Must be minimum 3 characters")
    //   .max(128, "Must be maximum 128 characters"),
    first_name: yup
      .string()
      .required("Enter your first name")
      .min(2, "Must be minimum 2 characters")
      .max(128, "Must be maximum 128 characters"),
    last_name: yup
      .string()
      .required("Enter your last name")
      .min(2, "Must be minimum 2 characters")
      .max(128, "Must be maximum 128 characters"),
    mobile_number: yup
      .string()
      .required("Enter your mobile number")
      .test(
        "mobileNumber",
        "Enter your mobile number",
        (value) =>
          !!value?.match(/(((\+44)? ?(\(0\))? ?)|(0))([ |-]?[1-9]{1}[0-9]{3})([ |-]?[0-9]{6}){1}/),
      ),
    email: yup
      .string()
      .required("Enter a valid email address")
      .email("Enter a valid email address"),
    date_of_birth: yup
      .string()
      .required("Enter your date of birth")
      .test("dateOfBirth", "Enter a valid date of birth", (value) => {
        return (
          moment().diff(moment(value), "years") >= 18 &&
          moment().diff(moment(value), "years") <= 100
        );
      }),
    relationship_with_main_applicant: yup.string().required("Relationship is required").nullable(),
    secondaryApplicants: yup
      .array()
      .test(
        "emailToCheck",
        "This matches applicant one’s email. You must enter applicant two’s email here",
        function (value, { createError }) {
          if (
            value?.length !== 0 &&
            value &&
            this.parent.email.toLowerCase().trim() === value[0].email.toLowerCase().trim()
          ) {
            return createError({
              path: "customErrorEmail",
              message:
                "This matches applicant one’s email. You must enter applicant two’s email here",
            });
          } else return true;
        },
      )
      .test(
        "mobileNumberToCheck",
        "This matches applicant one’s phone number. You must enter applicant two’s phone number here",
        function (value, { createError }) {
          if (
            value?.length !== 0 &&
            value &&
            this.parent.mobile_number === value[0].mobile_number
          ) {
            return createError({
              path: "customErrorMobile",
              message:
                "This matches applicant one’s phone number. You must enter applicant two’s phone number here",
            });
          } else return true;
        },
      )
      .of(
        yup
          .object()
          .shape({
            first_name: yup
              .string()
              .required("Enter your first name")
              .min(2, "Must be minimum 2 characters")
              .max(128, "Must be maximum 128 characters")
              .nullable(),
            last_name: yup
              .string()
              .required("Enter your last name")
              .min(2, "Must be minimum 2 characters")
              .max(128, "Must be maximum 128 characters")
              .nullable(),
            email: yup
              .string()
              .required("Enter a valid email address")
              .email("Enter a valid email address")
              .nullable(),
            mobile_number: yup
              .string()
              .required("Enter your mobile number")
              .test(
                "mobileNumber",
                "Enter your mobile number",
                (value) =>
                  !!value?.match(
                    /(((\+44)? ?(\(0\))? ?)|(0))([ |-]?[1-9]{1}[0-9]{3})([ |-]?[0-9]{6}){1}/,
                  ),
              ),
            date_of_birth: yup
              .string()
              .required("Enter your date of birth")
              .test("dateOfBirth", "Enter a valid date of birth", (value) => {
                return (
                  moment().diff(moment(value), "years") >= 18 &&
                  moment().diff(moment(value), "years") <= 100
                );
              }),
            relationship_with_main_applicant: yup
              .string()
              .required("Relationship with main applicant is required")
              .min(3, "Must be minimum 3 characters")
              .max(128, "Must be maximum 128 characters")
              .nullable(),
          })
          .nullable(),
      )
      .nullable(),
  })
  .required();

export const personalDetailsSchema = yup
  .object({
    first_name: yup
      .string()
      .required("Enter your first name")
      .min(2, "Must be minimum 2 characters")
      .max(128, "Must be maximum 128 characters"),
    last_name: yup
      .string()
      .required("Enter your last name")
      .min(2, "Must be minimum 2 characters")
      .max(128, "Must be maximum 128 characters"),
    date_of_birth: yup
      .string()
      .required("Enter your date of birth")
      .test("dateOfBirth", "Enter a valid date of birth", (value) => {
        return (
          moment().diff(moment(value), "years") >= 18 &&
          moment().diff(moment(value), "years") <= 100
        );
      }),
    mobile_number: yup
      .string()
      .required("Enter your mobile number")
      .test(
        "mobileNumber",
        "Enter your mobile number",
        (value) =>
          !!value?.match(/(((\+44)? ?(\(0\))? ?)|(0))([ |-]?[1-9]{1}[0-9]{3})([ |-]?[0-9]{6}){1}/),
      ),
  })
  .required();

export const qualifyingCriteriaSchema = yup
  .object({
    is_allowed_to_live_in_uk: yup.string().nullable().required("Please choose one"),
    // has_fraud_or_crime: yup.string().nullable().required("Please choose one"),
    has_criminal_record: yup.string().nullable().required("Please choose one"),
    is_bankrupt_or_iva: yup.string().nullable().required("Please choose one"),
    missed_any_payments: yup.string().nullable().required("Please choose one"),
    income_more_than_30k: yup.string().nullable().required("Please choose one"),
  })
  .required();

export const secondaryQualifyingCriteriaSchema = yup
  .object({
    is_allowed_to_live_in_uk: yup.string().nullable().required("Please choose one"),
    // has_fraud_or_crime: yup.string().nullable().required("Please choose one"),
    has_criminal_record: yup.string().nullable().required("Please choose one"),
    is_bankrupt_or_iva: yup.string().nullable().required("Please choose one"),
    missed_any_payments: yup.string().nullable().required("Please choose one"),
    // income_more_than_30k: yup.string().nullable().required("Please choose one"),
  })
  .required();

export const propertySchema = yup.object({
  hasLivingLocation: yup.string().nullable().required("Please choose one"),
  preferredLocation: yup
    .string()
    .nullable()
    .when("hasLivingLocation", {
      is: "1",
      then: yup
        .string()
        .nullable()
        .max(256, "Must be maximum 256 characters")
        .required("Please type postcode or city name")
        .typeError("Please enter a valid value"),
      otherwise: yup.string().optional(),
    }),
});

export const preferredPropertySchema = yup.object({
  hasLivingLocation: yup.string().nullable().required("Please choose one"),
  preferred_locations: yup
    .array()
    .nullable()
    .of(yup.string().nullable())
    .when("hasLivingLocation", {
      is: "1",
      then: yup
        .array()
        .of(yup.string().nullable().required("Choose at least one"))
        .test("preferred_locations", "Choose at least one", (value) => {
          return value?.length !== 0;
        }),
    }),

  hasPreferredProperty: yup.string().nullable().required("Please choose one"),

  preferred_property_type: yup
    .string()
    .nullable()
    .when("hasPreferredProperty", {
      is: "1",
      then: yup.string().nullable().required("Choose one"),
      otherwise: yup.string().optional().notRequired(),
    }),

  preferred_number_of_bedrooms: yup
    .string()
    .nullable()
    .when("hasPreferredProperty", {
      is: "1",
      then: yup.string().nullable().required("Choose one"),
      otherwise: yup.string().optional().notRequired(),
    }),

  preferred_number_of_bathrooms: yup
    .string()
    .nullable()
    .when("hasPreferredProperty", {
      is: "1",
      then: yup.string().nullable().required("Choose one"),
      otherwise: yup.string().optional().notRequired(),
    }),

  preferred_has_parking_or_garage: yup
    .string()
    .nullable()
    .when("hasPreferredProperty", {
      is: "1",
      then: yup.string().nullable().required("Choose one"),
      otherwise: yup.string().optional().notRequired(),
    }),

  preferred_has_outdoor_space: yup
    .string()
    .nullable()
    .when("hasPreferredProperty", {
      is: "1",
      then: yup.string().nullable().required("Choose one"),
      otherwise: yup.string().optional().notRequired(),
    }),

  preferred_outdoor_space_types: yup
    .array()
    .of(yup.string())
    .when("preferred_has_outdoor_space", {
      is: "1",
      then: yup
        .array()
        .of(yup.string().required("Choose at least one"))
        .test("preferred_outdoor_space_types", "Choose at least one", (value) => {
          return value?.length !== 0;
        }),
      otherwise: yup.array().optional(),
    }),

  preferred_special_access_desc: yup.string().optional().notRequired(),

  preferred_important_desc: yup.string().optional().notRequired(),

  preferred_pet_friendly: yup
    .string()
    .nullable()
    .when("hasPreferredProperty", {
      is: "1",
      then: yup.string().nullable().required("Choose one"),
      otherwise: yup.string().optional().notRequired(),
    }),
});

export const passwordSchema = yup
  .object({
    password: yup
      .string()
      .nullable()
      .required("This is required field")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\W])(?=.{8,})/,
        "Must contain 8 characters, one uppercase, one lowercase, one number and one special case character",
      ),
    passwordRepeat: yup
      .string()
      .nullable()
      .required("This is required field")
      .oneOf([yup.ref("password"), null], "Passwords must match"),
  })
  .required();

export const loginSchema = yup
  .object({
    email: yup
      .string()
      .required("Enter a valid email address")
      .email("Enter a valid email address"),
  })
  .required();

export const shareBudgetSchema = yup
  .object({
    email: yup
      .string()
      .required("Enter a valid email address")
      .email("Enter a valid email address"),
  })
  .required();

export const sendEmailSchema = yup
  .object({
    name: yup
      .string()
      .required("Enter your full name")
      .min(3, "Must be minimum 3 characters")
      .max(128, "Must be maximum 128 characters")
      .matches(/^[a-zA-Z\s'-]+$/, "Name must not contain numbers"),
    email: yup
      .string()
      .required("Enter a valid email address")
      .email("Enter a valid email address"),
    message: yup.string().required("Enter your message").min(10, "Must be minimum 10 characters"),
  })
  .required();

export const addressSchema = yup
  .object({
    houseNumber: yup
      .string()
      .required("House / flat number is required")
      .min(1, "Must be minimum 1 characters")
      .max(128, "Must be maximum 128 characters"),
    address: yup
      .string()
      .required("Address is required")
      .min(3, "Must be minimum 3 characters")
      .max(128, "Must be maximum 128 characters"),
    cityOrTown: yup
      .string()
      .required("Town / city is required")
      .min(3, "Must be minimum 3 characters")
      .max(128, "Must be maximum 128 characters"),
    askingPrice: yup
      .number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .max(1000000000, "Asking price must be less than £100,000,000,000")
      .min(130000, "We only buy homes worth £130,000 or more.")
      .required("Asking price is required"),

    postcode: yup
      .string()
      .nullable()
      .required("Post code is required")
      .matches(UKRegexp, "Must be a valid UK postcode"),

    linkToListing: yup.string().url("Enter a valid URL").optional().notRequired(),
  })
  .required();

export const aboutSchema = yup
  .object({
    formal_title: yup.string().nullable().required("Please choose one"),
    first_name: yup
      .string()
      .required("Enter your first name")
      .min(2, "Must be minimum 2 characters")
      .max(128, "Must be maximum 128 characters"),
    last_name: yup
      .string()
      .required("Enter your last name")
      .min(2, "Must be minimum 2 characters")
      .max(128, "Must be maximum 128 characters"),
    nationality: yup
      .string()
      .min(1, "Must be a valid value")
      .max(256, "Must be maximum 256 characters")
      .nullable()
      .required("Enter your nationality"),
    date_of_birth: yup
      .string()
      .required("Enter your date of birth")
      .test("dateOfBirth", "Enter a valid date of birth", (value) => {
        return (
          moment().diff(moment(value), "years") >= 18 &&
          moment().diff(moment(value), "years") <= 100
        );
      }),
    mobile_number: yup
      .string()
      .required("Enter your mobile number")
      .test(
        "mobileNumber",
        "Enter your mobile number",
        (value) =>
          !!value?.match(/(((\+44)? ?(\(0\))? ?)|(0))([ |-]?[1-9]{1}[0-9]{3})([ |-]?[0-9]{6}){1}/),
      ),
    national_insurance_number: yup
      .string()
      .required("Enter a valid national insurance number")
      .nullable()
      .matches(
        /^(?!BG|GB|NK|KN|TN|NT|ZZ)((?![DFIQUV])([A-Z])(?![DFIQUVO])([A-Z]))[0-9]{6}[A-D ]$/,
        "Must be a valid national insurance number",
      ),
    relationship_status: yup.string().nullable().required("Choose one"),
    is_on_the_voters_roll: yup.string().nullable().required("Choose one"),
    is_first_time_buyer: yup.string().nullable().required("Choose one"),
    is_moving_or_buying: yup.string().nullable().required("Choose one"),
  })
  .required();

export const leaseTypeSchema = yup.object({
  lease_type: yup.string().nullable().required("Please choose one"),
  remaining_years_on_lease: yup
    .number()
    .nullable()
    .when("leaseType", {
      is: "LEASEHOLD",
      then: yup
        .number()
        .min(0, "Enter a valid number")
        .max(999, "Enter a valid number")
        .typeError("Enter a valid number")
        .optional()
        .nullable()
        .required("This field is required"),
      otherwise: yup.number().nullable().optional().notRequired(),
    }),
  service_charge: yup
    .number()
    .nullable()
    .transform((v) => (Number.isNaN(v) ? null : v))
    .max(1000000000, "Service charge must be less than £1,000,000,000")
    .min(0.01, "Enter a valid number")
    .typeError("Enter a valid number")
    .optional()
    .notRequired(),
  ground_rent: yup
    .number()
    .transform((v) => (Number.isNaN(v) ? null : v))
    .max(1000000000, "Ground rent must be less than £1,000,000,000")
    .min(0.01, "Enter a valid number")
    .optional()
    .nullable()
    .notRequired(),
});

export const propertyTypeSchema = yup.object({
  propertyType: yup.string().nullable().required("Please choose one"),
  buildingType: yup.string().nullable().required("Please choose one"),
  houseType: yup
    .string()
    .nullable()
    .when("propertyType", {
      is: "HOUSE",
      then: yup.string().nullable().required("Please choose one"),
    })
    .when("propertyType", {
      is: "FLAT",
      then: yup.string().nullable().required("Please choose one"),
    }),
});

export const estateAgentSchema = yup
  .object()
  .shape({
    usingEstateAgent: yup.string().nullable().required("Choose one"),
    agentEmail: yup.string().email("Must be a vaild email").optional().nullable().notRequired(),
    agentName: yup
      .string()
      .max(255, "Must be maximum 255 characters")
      .optional()
      .nullable()
      .notRequired(),
    agentCompanyName: yup
      .string()
      .max(255, "Must be maximum 255 characters")
      .optional()
      .nullable()
      .notRequired(),
  })
  .test("atLeastOneValid", (value, { createError }) => {
    if (value.usingEstateAgent === "1") {
      if (
        !value.agentEmail &&
        !value.agentName &&
        (!value.agentPhoneNumber || value.agentPhoneNumber === "+44 (0) ____-______") &&
        !value.agentCompanyName
      ) {
        return createError({
          path: "customError",
          message: "Please fill at least one field",
        });
      } else return true;
    }

    return true;
  });

export const creditAndStoreCardsSchema = yup.object({
  has_outstanding_balance: yup.string().nullable().required("Please choose one"),
  unpaid_outstanding_balance: yup
    .number()
    .nullable()
    .when("has_outstanding_balance", {
      is: "1",
      then: yup
        .number()
        .min(0.01, "Enter a valid number")
        .max(1000000000, "Unpaid outstanding balance must be less than £1,000,000,000")
        .typeError("Enter a valid number")
        .required("This field is required"),
    })
    .when("has_outstanding_balance", {
      is: "0",
      then: yup.number().nullable().optional(),
    }),
});

export const loansAndMortgagesSchema = yup.object({
  personalLoanRepayment: yup
    .number()
    .max(1000000000, "Personal loan repayment must be less than £1,000,000,000")
    .min(0.01, "Enter a valid number")
    .optional()
    .notRequired()
    .nullable(),
  studentLoanRepayment: yup
    .number()
    .max(1000000000, "Student load payment must be less than £1,000,000,000")
    .min(0.01, "Enter a valid number")
    .optional()
    .notRequired()
    .nullable(),
  car_finance: yup
    .number()
    .max(1000000000, "Car finance payment must be less than £1,000,000,000")
    .min(0.01, "Enter a valid number")
    .optional()
    .notRequired()
    .nullable(),

  has_existing_mortgage: yup.string().nullable().required("Please choose one"),

  mortgage_repayment: yup
    .number()
    .nullable()
    .when("has_existing_mortgage", {
      is: "1",
      then: yup
        .number()
        .transform((v) => (Number.isNaN(v) ? null : v))
        .max(1000000000, "Mortgage repayment payment must be less than £1,000,000,000")
        .min(0.01, "Enter a valid number")
        .nullable()
        .required("Mortgage repayment is required"),
      otherwise: yup.number().optional().nullable().notRequired(),
    }),

  is_currently_renting: yup.string().nullable().required("Please choose one"),

  rent_payments: yup
    .number()
    .nullable()
    .when("is_currently_renting", {
      is: "1",
      then: yup
        .number()
        .transform((v) => (Number.isNaN(v) ? null : v))
        .max(1000000000, "Rent payment must be less than £1,000,000,000")
        .min(0.01, "Enter a valid number")
        .nullable()
        .required("Rent payment is required"),
      otherwise: yup.number().optional().nullable().notRequired(),
    }),

  has_savings: yup.string().nullable().required("Please choose one"),

  savings: yup
    .number()
    .nullable()
    .when("has_savings", {
      is: "1",
      then: yup
        .number()
        .transform((v) => (Number.isNaN(v) ? null : v))
        .max(1000000000, "Amount must be less than £1,000,000,000")
        .min(0.01, "Enter a valid number")
        .nullable()
        .required("Amount is required"),
      otherwise: yup.number().optional().nullable().notRequired(),
    }),
});

export const dependandantsSchema = yup
  .object({
    financed_children: yup.string().nullable().required("Please choose one"),
    finance_adults: yup.string().nullable().required("Please choose one"),
    maintenance_payments: yup
      .number()
      .transform((v) => (Number.isNaN(v) ? null : v))
      .max(1000000000, "Must be less than £1,000,000,000")
      .min(0.01, "Enter a valid number")
      .optional()
      .notRequired(),
    csaOrCourtOrderPayment: yup
      .number()
      .transform((v) => (Number.isNaN(v) ? null : v))
      .max(1000000000, "Must be less than £1,000,000,000")
      .min(0.01, "Enter a valid number")
      .optional()
      .notRequired(),
    schoolNurseryOrChildcareFees: yup
      .number()
      .transform((v) => (Number.isNaN(v) ? null : v))
      .max(1000000000, "Must be less than £1,000,000,000")
      .min(0.01, "Enter a valid number")
      .optional()
      .notRequired(),
  })
  .required();

export const addressHistorySchema = yup.object().shape({
  addresses: yup.array().of(
    yup.object().shape({
      street: yup.string().required("Street address is required"),
      city: yup.string().required("City is required"),
      country_code: yup.string().required("Country is required"),
      postal_code: yup.string().required("Post code is required"),
      date_moved_in: yup.string().required("This field is required"),
    }),
  ),
});

export const propertyInformationSchema = yup.object().shape({
  internal_area: yup
    .number()
    .min(400, "We only accept properties above 400 square feet")
    .max(10000, "We only accept properties below 10,000 square feet")
    .typeError("Enter a valid number")
    .required(),
  number_of_floors: yup.string().nullable().required("This field is required"),
  number_of_bedrooms: yup.string().nullable().required("This field is required"),
  number_of_bathrooms: yup.string().nullable().required("This field is required"),
  floor_number: yup
    .string()
    .nullable()
    .when("property_type", {
      is: "FLAT",
      then: yup
        .string()
        .nullable()
        .max(10, "Must be maximum 10 characters")
        .required("This field is required"),
    }),

  has_parking_or_garage: yup.string().nullable().required("This field is required"),
  has_outdoor_space: yup.string().nullable().required("This field is required"),
  outdoor_space_types: yup
    .array()
    .of(yup.string().nullable())
    .when("has_outdoor_space", {
      is: "1",
      then: yup
        .array()
        .of(yup.string().nullable().required("This field is required"))
        .test("outdoor_space_types", "This field is required", (value) => {
          return value?.length !== 0;
        }),
    }),
  number_of_other_rooms: yup.string().nullable().required("This field is required"),
  epc_rating: yup.string().nullable().required("Please choose one"),
});

export const yourOfferSchema = yup.object().shape({
  asking_price: yup
    .number()
    .transform((value) => (isNaN(value) ? undefined : value))
    .max(100000000000, "Your asking price must be less than £100,000,000,000")
    .min(130000, "We only buy homes worth £130,000 or more.")
    .required("Asking price is required"),
  offer_made: yup.string().nullable().required("Choose one"),
  offer_amount: yup
    .number()
    .nullable()
    .when("offer_made", {
      is: "0",
      then: yup
        .number()
        .transform((v) => (Number.isNaN(v) ? null : v))
        .nullable()
        .notRequired(),
    })
    .when("offer_made", {
      is: "1",
      then: yup
        .number()
        .typeError("This field is required")
        .min(0.01, "Enter a valid number")
        .max(1000000000, "Your offer amount must be less than £1,000,000,000")
        .min(130000, "We only buy homes worth £130,000 or more.")
        .required("This field is required"),
    }),
  offer_status: yup
    .string()
    .nullable()

    .when("offer_made", {
      is: "1",
      then: yup
        .string()
        .nullable()
        .min(0.01, "Enter a valid number")
        .max(1000000000, "Your offer amount must be less than £1,000,000,000")
        .required("This field is required"),
    })
    .when("offer_made", {
      is: "0",
      then: yup.string().nullable().optional(),
    }),
  offer_accepted_at: yup
    .string()
    .nullable()
    .when(["offer_status", "offer_made"], {
      is: (offerStatus: string, offerMade: string) =>
        offerStatus === "ACCEPTED" && offerMade === "1",
      then: yup
        .string()
        .required("This field is required")
        .test("acceptedAt", "Enter a valid date", (value) => moment().isAfter(moment(value))),
    })
    .when("offer_made", {
      is: "0",
      then: yup.string().nullable().optional(),
    }),
});

export const incomeSourcesSchema = yup.object().shape({
  bonusIncome: yup
    .number()
    .nullable()
    .max(1000000000, "Total income income must be less than £1,000,000,000")
    .when("sourceType", {
      is: (sourceType: string) => ["BENEFITS", "PENSION", "OTHER"].includes(sourceType),
      then: yup
        .number()
        .nullable()
        .typeError("Enter a valid number")
        .required("This field is required"),
    }),
});

const primarySourceOfIncomeBaseSchema = yup.object().shape({
  sourceType: yup.string().nullable().required("Please choose one"),
  contractType: yup
    .string()
    .nullable()
    .when("sourceType", {
      is: "EMPLOYMENT_CONTRACT",
      then: yup.string().nullable().required("Please choose one"),
      otherwise: yup.string().optional().nullable().notRequired(),
    }),

  companyName: yup
    .string()
    .nullable()
    .when("sourceType", {
      is: (sourceType: string) =>
        ["EMPLOYMENT_CONTRACT", "SOLE_TRADER_OR_PARTNERSHIP", "LIMITED_COMPANY"].includes(
          sourceType,
        ),
      then: yup
        .string()
        .max(255, "Must be maximum 255 characters")
        .nullable()
        .required("This field is required"),
      otherwise: yup.string().optional().notRequired(),
    }),

  jobTitle: yup
    .string()
    .nullable()
    .when("sourceType", {
      is: (sourceType: string) =>
        ["EMPLOYMENT_CONTRACT", "SOLE_TRADER_OR_PARTNERSHIP", "LIMITED_COMPANY"].includes(
          sourceType,
        ),
      then: yup
        .string()
        .max(255, "Must be maximum 255 characters")
        .nullable()
        .required("This field is required"),
      otherwise: yup.string().optional().notRequired(),
    }),

  employmentStartedAt: yup
    .string()
    .nullable()
    .when("sourceType", {
      is: (sourceType: string) =>
        ["EMPLOYMENT_CONTRACT", "SOLE_TRADER_OR_PARTNERSHIP", "LIMITED_COMPANY"].includes(
          sourceType,
        ),
      then: yup
        .string()
        .required("This field is required")
        .test("employmentStartedAt", "Enter a valid date", (value) =>
          moment().isAfter(moment(value)),
        ),
      otherwise: yup.string().optional().notRequired(),
    }),

  workplacePostalCode: yup
    .string()
    .nullable()
    .when("sourceType", {
      is: (sourceType: string) =>
        ["EMPLOYMENT_CONTRACT", "SOLE_TRADER_OR_PARTNERSHIP", "LIMITED_COMPANY"].includes(
          sourceType,
        ),
      then: yup.string().nullable().required("This field is required"),
      otherwise: yup.string().optional().notRequired(),
    }),

  industry: yup
    .string()
    .nullable()
    .when("sourceType", {
      is: (sourceType: string) =>
        ["EMPLOYMENT_CONTRACT", "SOLE_TRADER_OR_PARTNERSHIP", "LIMITED_COMPANY"].includes(
          sourceType,
        ),
      then: yup
        .string()
        .max(255, "Must be maximum 255 characters")
        .nullable()
        .required("This field is required"),
      otherwise: yup.string().optional().notRequired(),
    }),

  sourceDescription: yup
    .string()
    .nullable()
    .when("sourceType", {
      is: "OTHER",
      then: yup
        .string()
        .nullable()
        .max(256, "Must be maximum 256 characters")
        .required("This field is required"),
      otherwise: yup.string().optional().notRequired(),
    }),
});

export const otherIncome = yup.object().shape({
  otherIncome: yup
    .number()
    .nullable()
    .transform((v) => (Number.isNaN(v) ? null : v))
    .typeError("Enter a valid number")
    .max(1000000000, "Must be less than £1,000,000,000")
    .when("sourceType", {
      is: (sourceType: string) => ["BENEFITS", "PENSION", "OTHER"].includes(sourceType),
      then: yup
        .number()
        .nullable()
        .typeError("Enter a valid number")
        .required("This field is required"),
      otherwise: yup.number().nullable().optional().notRequired(),
    }),
});

export const primarySourceOfIncomeSchema = primarySourceOfIncomeBaseSchema.concat(incomeSchema);

export const primarySourceWithBonusIncomeSchema =
  primarySourceOfIncomeBaseSchema.concat(incomeSourcesSchema);

export const otherSourceOfIncomeBaseSchema = yup.object({
  hasOtherIncomes: yup.string().nullable().required("Please choose one"),
  otherSourceType: yup
    .array()
    .of(yup.string().nullable())

    .when("hasOtherIncomes", {
      is: "1",
      then: yup
        .array()
        .of(yup.string().nullable().required("This field is required"))
        .test("otherSourceType", "This field is required", (value) => {
          return value?.length !== 0;
        }),
    }),
});

export const landlordsSignUpSchema = yup
  .object({
    full_name: yup
      .string()
      .trim()
      .required("Enter your name")
      .min(2, "Must be minimum 2 characters")
      .max(128, "Must be maximum 128 characters"),
    email: yup
      .string()
      .trim()
      .required("Enter a valid email address")
      .email("Enter a valid email address"),
    mobile_number: yup
      .string()
      .required("Enter your mobile number")
      .test(
        "mobileNumber",
        "Enter your mobile number",
        (value) =>
          !!value?.match(/(((\+44)? ?(\(0\))? ?)|(0))([ |-]?[1-9]{1}[0-9]{3})([ |-]?[0-9]{6}){1}/),
      ),
  })
  .required();

export const landlordsPropertySchema = yup
  .object({
    street_address: yup.string().required("Street address is required"),
    post_code: yup.string().required("Post code is required"),
    number_of_bedrooms: yup.string().nullable().required("This field is required"),
  })
  .required();

export const otherSourceOfIncomeSchema = primarySourceOfIncomeBaseSchema.concat(otherIncome);

export const manageAccountSingle = yup
  .object({
    primary_mobile_number: yup
      .string()
      .nullable()
      .required("Enter your mobile number")
      .test(
        "secondary_mobile_number",
        "Enter your mobile number",
        (value) =>
          !!value?.match(/(((\+44)? ?(\(0\))? ?)|(0))([ |-]?[1-9]{1}[0-9]{3})([ |-]?[0-9]{6}){1}/),
      ),
    primary_email: yup
      .string()
      .nullable()
      .required("Enter a valid email address")
      .email("Enter a valid email address"),
  })
  .required();

export const manageAccountDouble = yup
  .object({
    primary_mobile_number: yup
      .string()
      .nullable()
      .required("Enter your mobile number")
      .test(
        "secondary_mobile_number",
        "Enter your mobile number",
        (value) =>
          !!value?.match(/(((\+44)? ?(\(0\))? ?)|(0))([ |-]?[1-9]{1}[0-9]{3})([ |-]?[0-9]{6}){1}/),
      ),
    primary_email: yup
      .string()
      .nullable()
      .required("Enter a valid email address")
      .email("Enter a valid email address"),
    secondary_mobile_number: yup
      .string()
      .nullable()
      .required("Enter your mobile number")
      .test(
        "primary_mobile_number",
        "Enter your mobile number",
        (value) =>
          !!value?.match(/(((\+44)? ?(\(0\))? ?)|(0))([ |-]?[1-9]{1}[0-9]{3})([ |-]?[0-9]{6}){1}/),
      ),
    secondary_email: yup
      .string()
      .nullable()
      .required("Enter a valid email address")
      .email("Enter a valid email address"),
  })
  .required();

export const aboutRentApplicantSchema = (existingPhones: string[] = []) =>
  yup
    .object({
      first_name: yup
        .string()
        .required("Enter your first name")
        .min(2, "Must be minimum 2 characters")
        .max(128, "Must be maximum 128 characters"),
      last_name: yup
        .string()
        .required("Enter your last name")
        .min(2, "Must be minimum 2 characters")
        .max(128, "Must be maximum 128 characters"),
      mobile_number: yup
        .string()
        .required("Enter your mobile number")
        .test(
          "mobileNumber",
          "Enter your mobile number",
          (value) =>
            !!value?.match(
              /(((\+44)? ?(\(0\))? ?)|(0))([ |-]?[1-9]{1}[0-9]{3})([ |-]?[0-9]{6}){1}/,
            ),
        )
        .test("unique-phone", "An applicant with this mobile number already exists.", (value) => {
          if (!value) return true;
          const phone = normalizePhone(value);
          return !existingPhones.map(normalizePhone).includes(phone);
        }),
      is_first_time_buyer: yup.string().nullable().required("Choose one"),
    })
    .required();

export const addressRentalApplicantHistorySchema = yup.object().shape({
  addresses: yup.array().of(
    yup.object().shape({
      id: yup.string().nullable(),
      street_address: yup.string().required("Street address is required"),
      city: yup.string().required("City is required"),
      country: yup.string().required("Country is required"),
      post_code: yup
        .string()
        .required("Post code is required")
        .matches(UKRegexp, "Must be a valid UK postcode"),
      move_in_date: yup.string().required("This field is required"),
    }),
  ),
});

export const primarySourceOfIncomeV2Schema = yup
  .object({
    source_type: yup
      .string()
      .oneOf([
        "EMPLOYMENT_CONTRACT",
        "SOLE_TRADER_OR_PARTNERSHIP",
        "LIMITED_COMPANY",
        "BENEFITS",
        "PENSION",
        "OTHER",
      ])
      .required("Please choose one"),

    contract_type: yup
      .string()
      .nullable()
      .when("source_type", {
        is: "EMPLOYMENT_CONTRACT",
        then: (schema) => schema.required("Please choose one"),
        otherwise: (schema) => schema.notRequired().nullable(),
      }),

    company_name: yup
      .string()
      .nullable()
      .when("source_type", {
        is: (val: string) =>
          ["EMPLOYMENT_CONTRACT", "SOLE_TRADER_OR_PARTNERSHIP", "LIMITED_COMPANY"].includes(val),
        then: (schema) => schema.max(255).required("This field is required").trim(),
        otherwise: (schema) => schema.notRequired().nullable().trim(),
      }),

    job_title: yup
      .string()
      .nullable()
      .when("source_type", {
        is: (val: string) =>
          ["EMPLOYMENT_CONTRACT", "SOLE_TRADER_OR_PARTNERSHIP", "LIMITED_COMPANY"].includes(val),
        then: (schema) => schema.max(255).required("This field is required").trim(),
        otherwise: (schema) => schema.notRequired().nullable().trim(),
      }),

    employment_started_at: yup
      .string()
      .nullable()
      .when("source_type", {
        is: (val: string) =>
          ["EMPLOYMENT_CONTRACT", "SOLE_TRADER_OR_PARTNERSHIP", "LIMITED_COMPANY"].includes(val),
        then: (schema) =>
          schema
            .required("This field is required")
            .test("valid-date", "Enter a valid date", (value) =>
              value ? moment().isAfter(moment(value)) : false,
            ),
        otherwise: (schema) => schema.notRequired().nullable(),
      }),

    workplace_postal_code: yup
      .string()
      .nullable()
      .when("source_type", {
        is: (val: string) =>
          ["EMPLOYMENT_CONTRACT", "SOLE_TRADER_OR_PARTNERSHIP", "LIMITED_COMPANY"].includes(val),
        then: (schema) =>
          schema
            .required("This field is required")
            .matches(UKRegexp, "Must be a valid UK postcode"),
        otherwise: (schema) => schema.notRequired().nullable(),
      }),

    industry: yup
      .string()
      .nullable()
      .when("source_type", {
        is: (val: string) =>
          ["EMPLOYMENT_CONTRACT", "SOLE_TRADER_OR_PARTNERSHIP", "LIMITED_COMPANY"].includes(val),
        then: (schema) => schema.max(255).required("This field is required").trim(),
        otherwise: (schema) => schema.notRequired().nullable().trim(),
      }),

    source_description: yup
      .string()
      .nullable()
      .when("source_type", {
        is: (val: string) => val === "OTHER" || val === "BENEFITS",
        then: (schema) =>
          schema
            .max(256, "Must be maximum 256 characters")
            .required("This field is required")
            .trim(),
        otherwise: (schema) => schema.notRequired().nullable().trim(),
      }),
    base_salary: yup
      .number()
      .nullable()
      .transform((v) => (Number.isNaN(v) ? null : v))
      .max(1000000000, "Must be less than £1,000,000,000"),

    bonus_income: yup
      .number()
      .nullable()
      .transform((v) => (Number.isNaN(v) ? null : v))
      .when("source_type", {
        is: (val: string) => ["BENEFITS", "PENSION", "OTHER"].includes(val),
        then: (schema) =>
          schema
            .required("Please enter the total income")
            .max(1000000000, "Must be less than £1,000,000,000"),
        otherwise: (schema) => schema.max(1000000000),
      }),

    commission: yup
      .number()
      .nullable()
      .transform((v) => (Number.isNaN(v) ? null : v))
      .max(1000000000),

    overtime_income: yup
      .number()
      .nullable()
      .transform((v) => (Number.isNaN(v) ? null : v))
      .max(1000000000),

    other_income: yup
      .number()
      .nullable()
      .transform((v) => (Number.isNaN(v) ? null : v))
      .max(1000000000),

    dividends: yup
      .number()
      .nullable()
      .transform((v) => (Number.isNaN(v) ? null : v))
      .max(1000000000),

    share_holding_percent: yup
      .number()
      .nullable()
      .transform((v) => (Number.isNaN(v) ? null : v))
      .min(0)
      .max(100),

    is_primary: yup.boolean().default(true),
  })
  .test("incomeValidation", function (value) {
    if (!value) return true;

    const { source_type } = value;

    // BONUS FLOW → bonus_income required (already enforced above)
    if (["BENEFITS", "PENSION", "OTHER"].includes(source_type ?? "")) {
      return true;
    }

    // EMPLOYMENT FLOW → at least one income field required
    const hasIncome =
      value.base_salary != null ||
      value.bonus_income != null ||
      value.commission != null ||
      value.overtime_income != null ||
      value.other_income != null;

    if (!hasIncome) {
      return this.createError({
        path: "customError",
        message: "Please provide at least one income",
      });
    }

    return true;
  });

export const otherSourceOfIncomeWithoutBonusSchema = yup.object().shape({
  source_type: yup
    .array()
    .of(
      yup.mixed<
        | "EMPLOYMENT_CONTRACT"
        | "SOLE_TRADER_OR_PARTNERSHIP"
        | "LIMITED_COMPANY"
        | "BENEFITS"
        | "PENSION"
        | "OTHER"
      >(),
    )
    .required(),
  is_primary: yup.boolean().optional(),
});
export const otherSourceOfIncomeV2Schema = yup.object().shape({
  id: yup.string().optional(),

  source_type: yup
    .mixed<
      | "EMPLOYMENT_CONTRACT"
      | "SOLE_TRADER_OR_PARTNERSHIP"
      | "LIMITED_COMPANY"
      | "BENEFITS"
      | "PENSION"
      | "OTHER"
    >()
    .required(),

  is_primary: yup.boolean().optional(),

  contract_type: yup.string().when("source_type", {
    is: "EMPLOYMENT_CONTRACT",
    then: (schema) => schema.required("Select contract type"),
    otherwise: (schema) => schema.optional(),
  }),

  company_name: yup.string().when("source_type", {
    is: (val: string) =>
      ["EMPLOYMENT_CONTRACT", "LIMITED_COMPANY", "SOLE_TRADER_OR_PARTNERSHIP"].includes(val),
    then: (schema) => schema.required("Company name is required"),
    otherwise: (schema) => schema.optional(),
  }),

  job_title: yup.string().when("source_type", {
    is: "EMPLOYMENT_CONTRACT",
    then: (schema) => schema.required("Job title is required"),
    otherwise: (schema) => schema.optional(),
  }),

  workplace_postal_code: yup.string().when("source_type", {
    is: (val: string) =>
      ["EMPLOYMENT_CONTRACT", "LIMITED_COMPANY", "SOLE_TRADER_OR_PARTNERSHIP"].includes(val),
    then: (schema) =>
      schema.required("Postcode is required").matches(UKRegexp, "Enter a valid UK postcode"),
    otherwise: (schema) => schema.optional(),
  }),

  industry: yup.string().optional(),

  employment_started_at: yup.string().when("source_type", {
    is: (val: string) =>
      ["EMPLOYMENT_CONTRACT", "LIMITED_COMPANY", "SOLE_TRADER_OR_PARTNERSHIP"].includes(val),
    then: (schema) => schema.required("Start date is required"),
    otherwise: (schema) => schema.optional(),
  }),

  base_salary: yup
    .number()
    .transform((value, originalValue) =>
      originalValue === "" || originalValue == null ? undefined : value,
    )
    .when("source_type", {
      is: (val: string) =>
        ["EMPLOYMENT_CONTRACT", "LIMITED_COMPANY", "SOLE_TRADER_OR_PARTNERSHIP"].includes(val),
      then: (schema) =>
        schema
          .typeError("Enter valid salary /profit")
          .required("Base salary is required")
          .min(1, "Enter valid salary / profit"),
      otherwise: (schema) => schema.optional(),
    }),

  bonus_income: yup
    .number()
    .transform((value, originalValue) =>
      originalValue === "" || originalValue == null ? undefined : value,
    )
    .min(0)
    .optional(),

  commission: yup
    .number()
    .transform((value, originalValue) =>
      originalValue === "" || originalValue == null ? undefined : value,
    )
    .min(0)
    .optional(),

  overtime_income: yup
    .number()
    .transform((value, originalValue) =>
      originalValue === "" || originalValue == null ? undefined : value,
    )
    .min(0)
    .optional(),

  other_income: yup
    .number()
    .transform((value, originalValue) =>
      originalValue === "" || originalValue == null ? undefined : value,
    )
    .when("source_type", {
      is: (val: string) => ["BENEFITS", "PENSION", "OTHER"].includes(val),
      then: (schema) =>
        schema.typeError("Enter valid income").required("Income amount is required").min(0),
      otherwise: (schema) => schema.optional(),
    }),

  source_description: yup.string().when("source_type", {
    is: (val: string) => ["BENEFITS", "OTHER"].includes(val),
    then: (schema) => schema.required("Description is required"),
    otherwise: (schema) => schema.optional(),
  }),
  dividends: yup
    .number()
    .nullable()
    .transform((v) => (Number.isNaN(v) ? null : v))
    .max(1000000000),

  share_holding_percent: yup
    .number()
    .nullable()
    .transform((v) => (Number.isNaN(v) ? null : v))
    .min(0)
    .max(100, "Enter valid percentage"),
});

export const otherIncomeSchema = yup.object({
  hasOtherIncomes: yup.string().oneOf(["0", "1"]).required("Please select an option"),

  otherSourceType: yup
    .array()
    .of(
      yup
        .string()
        .oneOf([
          "EMPLOYMENT_CONTRACT",
          "SOLE_TRADER_OR_PARTNERSHIP",
          "LIMITED_COMPANY",
          "BENEFITS",
          "PENSION",
          "OTHER",
        ]),
    )
    .when("hasOtherIncomes", {
      is: "1",
      then: (schema) =>
        schema
          .min(1, "Please select at least one source of income")
          .required("Please select at least one source of income"),
      otherwise: (schema) =>
        schema
          .nullable()
          .optional()
          .transform(() => undefined),
    }),
});

export const rentalApplicantExpenditureSchema = yup.object({
  are_you_currently_renting: yup.string().required("Required"),
  monthly_rent: yup
    .number()
    .transform((v, o) => (o === "" ? undefined : v))
    .when("are_you_currently_renting", {
      is: "1",
      then: (s) => s.required("Enter monthly rent"),
      otherwise: (s) => s.optional(),
    }),

  have_existing_mortgage: yup.string().required("Required"),

  monthly_mortgage_payment: yup
    .number()
    .transform((v, o) => (o === "" ? undefined : v))
    .when("have_existing_mortgage", {
      is: "1",
      then: (s) => s.required("Enter mortgage payment"),
      otherwise: (s) => s.optional(),
    }),

  have_any_savings: yup.string().required("Required"),

  savings_amount: yup
    .number()
    .transform((v, o) => (o === "" ? undefined : v))
    .when("have_any_savings", {
      is: "1",
      then: (s) => s.required("Enter savings amount"),
      otherwise: (s) => s.optional(),
    }),

  have_credit_or_store_card_balance: yup.string().required("Required"),

  total_outstanding_balance: yup
    .number()
    .transform((v, o) => (o === "" ? undefined : v))
    .when("have_credit_or_store_card_balance", {
      is: "1",
      then: (s) => s.required("Enter outstanding balance"),
      otherwise: (s) => s.optional(),
    }),

  no_of_dependent_children: yup.mixed().required("Select number of children"),

  no_of_dependent_adults: yup
    .number()
    .typeError("Select number of adults")
    .required("Select number of adults"),

  maintenance_payments: yup
    .number()
    .transform((v, o) => (o === "" ? undefined : v))
    .nullable(),

  csa_or_court_order_payment: yup
    .number()
    .transform((v, o) => (o === "" ? undefined : v))
    .nullable(),

  school_nursery_and_childcare_fees: yup
    .number()
    .transform((v, o) => (o === "" ? undefined : v))
    .nullable(),
  financial_conducts: yup.string().required("Required"),
});

export const rentalApplicantEligibilitySchema = yup.object({
  entered_into_iva: yup
    .string()
    .nullable()
    .required("Please select whether you have entered into an IVA "),
  cca_or_default: yup
    .string()
    .nullable()
    .required("Please select whether you have a County Court Judgment (CCJ) or default"),
  missed_any_payments: yup
    .string()
    .nullable()
    .required("Please select whether you have missed any payments "),
});

export const rentalApplicationOfferWitnessSchema = yup.object({
  full_name: yup
    .string()
    .required("Enter your name")
    .trim()
    .test(
      "two-words",
      "Enter your full name (first and last name)",
      (value) => !!value && value.trim().split(/\s+/).filter(Boolean).length >= 2,
    ),
  email: yup.string().email("Enter a valid email address").required("Enter email address"),
});

export const rentalApplicationOfferMoveInDateSchema = yup.object({
  is_correct_previous_move_in_date: yup
    .string()
    .nullable()
    .required("Please select whether your previous move-in date is correct"),
  move_in_date: yup.string().when("is_correct_previous_move_in_date", {
    is: "0",
    then: (s) => s.required("Enter move-in date"),
    otherwise: (s) => s.optional(),
  }),
});

const stripMobileMask = (value: string | null | undefined): string => {
  if (!value) return "";
  return value
    .replace(/\+44\s?\(0\)\s?/g, "")
    .replace(/[-_\s]/g, "")
    .trim();
};

const normalizePhone = (num?: string | null): string => {
  if (!num) return "";
  let n = num
    .replace(/[\s\-\.]/g, "")
    .replace(/\(0\)/g, "")
    .replace(/^\+?44/, "44")
    .replace(/^0044/, "44")
    .replace(/^0/, "44");

  if (/^\d{10}$/.test(n)) {
    n = "44" + n;
  }

  return n;
};

export const addRentalApplicantSchema = (existingEmails: string[], existingPhones: string[]) =>
  yup.object({
    applicants: yup.array().of(
      yup.object({
        firstName: yup.string().required("Enter first name").trim(),
        lastName: yup.string().required("Enter last name").trim(),

        email: yup
          .string()
          .email("Enter a valid email address")
          .required("Enter email address")
          .test(
            "unique-email",
            "An applicant with this email already exists. Please use a different email address.",
            function (value) {
              if (!value) return true;

              const ctx = this.options.context as {
                existingEmails: string[];
                existingPhones: string[];
              };

              const email = value.toLowerCase();

              const applicants = this.parent?.applicants || [];

              const duplicateInForm =
                applicants.filter((a: any) => a.email?.toLowerCase() === email).length > 1;

              const duplicateInExisting = ctx.existingEmails
                .map((e) => e.toLowerCase())
                .includes(email);

              return !(duplicateInForm || duplicateInExisting);
            },
          ),

        mobileNumber: yup
          .string()
          .required("Enter mobile number")
          .test("mobile-format", "Enter a valid UK mobile number", (value) => {
            if (!value) return false;
            return /^7\d{9}$/.test(stripMobileMask(value));
          })
          .test(
            "unique-phone",
            "An applicant with this mobile number already exists. Please use a different mobile number.",
            function (value) {
              if (!value) return true;

              const phone = normalizePhone(value);

              const self = this as any;

              const existingPhones: string[] = this.options?.context?.existingPhones || [];
              const duplicateInExisting = existingPhones.map(normalizePhone).includes(phone);

              const formApplicants: any[] = self.from?.[1]?.value?.applicants || [];
              const matchesInForm = formApplicants.filter(
                (a: any) => normalizePhone(a.mobileNumber) === phone,
              );
              const duplicateInForm = matchesInForm.length > 1;

              return !(duplicateInExisting || duplicateInForm);
            },
          ),

        income: yup
          .number()
          .typeError("Please enter a valid income")
          .required("Income is required")
          .min(1, "Income must be greater than 0"),
      }),
    ),
  });

const applicantSchema = yup.object({
  firstName: yup
    .string()
    .trim()
    .required("First name is required")
    .min(2, "First name must be at least 2 characters"),

  lastName: yup
    .string()
    .trim()
    .required("Last name is required")
    .min(2, "Last name must be at least 2 characters"),

  email: yup
    .string()
    .required("Email address is required")
    .email("Please enter a valid email address")
    .test("tld-typo", "Please enter a valid email address", (value) =>
      !value ? true : !/\.c[ip90lk]m$/i.test(value),
    ),

  mobileNumber: yup
    .string()
    .required("Mobile number is required")
    .test("mobile-format", "Enter a valid UK mobile number", (value) => {
      if (!value) return false;
      const stripped = stripMobileMask(value);
      return /^7\d{9}$/.test(stripped);
    }),

  income: yup
    .number()
    .typeError("Please enter a valid income")
    .required("Income is required")
    .min(1, "Income must be greater than 0"),
});

export const RegisterRentalApplicantSchema = yup.object({
  missed_any_payments: yup
    .string()
    .nullable()
    .required("Please select whether you have missed any payments or have a CCJ/IVA")
    .oneOf(["0", "1"]),

  applicants: yup.array().when("missed_any_payments", {
    is: "0",
    then: (schema) =>
      schema.of(applicantSchema).required().min(1, "At least one applicant is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
});

export const YourHomeRentalApplicantSchema = yup.object({
  interested_in_current_development: yup.string().nullable().notRequired(),

  place_interested: yup
    .array()
    .of(yup.string())
    .min(1, "Please select at least one location you're interested in"),

  no_of_bedrooms: yup
    .array()
    .of(yup.string())
    .nullable()
    .min(1, "Please select the number of bedrooms you're looking for"),

  need_parking: yup.string().nullable().required("Please select whether you need parking"),

  special_access_requirements: yup.string().nullable().notRequired().trim(),

  other_requirements: yup.string().nullable().notRequired().trim(),

  looking_to_move_in: yup
    .string()
    .nullable()
    .required("Please select your expected move-in timeframe")
    .trim(),
});

export const YourAccountFormSchema = (applicantIds: string[]) =>
  yup
    .object(
      applicantIds.reduce<Record<string, yup.StringSchema>>((shape, applicantId) => {
        shape[`mobile_number_${applicantId}`] = yup
          .string()
          .test("mobile-format", "Please enter a valid UK mobile number", (value) => {
            return /^7\d{9}$/.test(stripMobileMask(value));
          });
        return shape;
      }, {}),
    )
    .test("unique-mobile-numbers", "unique-mobile-numbers", function (value) {
      const fieldNames = applicantIds.map((applicantId) => `mobile_number_${applicantId}`);
      const normalizedNumbers = fieldNames.map((fieldName) =>
        stripMobileMask((value as Record<string, string>)?.[fieldName]),
      );

      const duplicateFieldNames = fieldNames.filter((_fieldName, index) => {
        const number = normalizedNumbers[index];
        return !!number && normalizedNumbers.indexOf(number) !== index;
      });

      if (!duplicateFieldNames.length) return true;

      return new yup.ValidationError(
        duplicateFieldNames.map((fieldName) =>
          this.createError({
            path: fieldName,
            message: "Each applicant must use a different mobile number",
          }),
        ),
      );
    });
